module.exports = __webpack_public_path__ + "img/1.5d149e21.png";